
import { Component, Vue, Prop } from "vue-property-decorator";
import { clearFilter } from "@/utils/base";
@Component({})
export default class Name extends Vue {
  @Prop()
  private cState: any;
  private showYisheng: boolean = true;
  private showHuanzhe: boolean = true;
  private showNeirong: boolean = true;
  private showShaicha: boolean = true;
  private curTab: any = {};
  private openTab: any = {};
  private H: any = "";
  private get configuration() {
    return this.$store.state.configuration;
  }
  private get href() {
    return window.location.href;
  }
  private changeOpen(item: any) {
    item.open = !item.open;
  }
  private goRouter(item: any) {
    this.curTab = item;
    this.$store.commit("updatePatient", null);
    clearFilter();
    this.$router.push(item.path);
  }
  private iconfont(icon: any) {
    const reg: any = /(&#x)?(.*)/;
    let iconfontName: any;
    if (reg.test(icon)) {
      iconfontName = reg.exec(icon)[2];
    }
    return String.fromCharCode(parseInt(iconfontName, 16));
  }
  mounted() {
    this.H = document.body.clientHeight - 70;
    const path = window.location.href.split("#")[1];
    this.configuration.leftNav.forEach((element: any) => {
      if (element.children) {
        element.children.forEach((ele: any) => {
          if (path == ele.activePath) {
            this.curTab = ele;
            element.open = true;
          }
        });
      } else {
        if (path == element.activePath) {
          this.curTab = element;
        }
      }
    });
  }
}
